import { render, staticRenderFns } from "./ADNewAssignmentItem.vue?vue&type=template&id=04ec509b&scoped=true"
import script from "./ADNewAssignmentItem.vue?vue&type=script&lang=js"
export * from "./ADNewAssignmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec509b",
  null
  
)

export default component.exports